import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft, LayoutTemplate } from "lucide-react";
import PaymentReceipt from "./PaymentReceipt";

interface ReceiptSettingsProps {
  schoolId: string | null;
  onBack: () => void;
}

const dummyTransaction = {
  studentName: "JOHN DOE",
  regNumber: "ADM-123456",
  amount: 25500,
  reference: "CASH-TEST001",
  date: new Date(),
  method: "Cash",
  className: "FORM 3 EAST",
  termLabel: "Term 1 2026",
};

const ReceiptSettings: React.FC<ReceiptSettingsProps> = ({ schoolId, onBack }) => {

  return (
    <div className="flex flex-col h-full bg-transparent text-foreground overflow-y-auto p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-6">
        <Button 
          variant="outline"
          size="sm"
          onClick={onBack}
          className="gap-2 w-fit border-gray-300 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          <span>Back</span>
        </Button>
        <div>
          <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-foreground flex items-center gap-2">
            <LayoutTemplate className="h-6 w-6 text-blue-600 dark:text-blue-500" />
            Receipt Designs & Preview
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Preview the available receipt layouts for cash transactions.
          </p>
        </div>
      </div>
      
      <div className="flex-1 w-full mx-auto space-y-6 pb-20 fade-in zoom-in duration-300">
        <PaymentReceipt 
          schoolId={schoolId} 
          transactionInfo={dummyTransaction} 
        />
      </div>
    </div>
  );
};

export default ReceiptSettings;
